import React from 'react'
import styled from 'styled-components'

import CustomizedReport from 'pared/components/CustomizedReport'

const UserEventLogTable = () => {
  return (
    <Container>
      <TitleDiv>User Events</TitleDiv>
      <CustomizedReport
        reportName="USER_EVENT_LOG_TABLE"
        inputParams={{}}
        rowKey={({ email }) => email}
      />
    </Container>
  )
}

const Container = styled.div`
  margin: 0;
  padding: 0;
`

const TitleDiv = styled.div`
  font-family: Lexend-SemiBold;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  margin-bottom: 40px;
`

export default React.memo(UserEventLogTable)
